import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 34\" id=\"icon-close\"><path d=\"M26.916 9.083l-2-2-7.919 7.919-7.914-7.919-2 2 7.919 7.919-7.919 7.917 2 2L17.002 19l7.919 7.919 2-2L19.002 17z\" /><path d=\"M0 0h34v34H0z\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol